const planetSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="23.041px" height="22.621px" viewBox="0 0 23.041 22.621" enable-background="new 0 0 23.041 22.621" xml:space="preserve">
<g>
	<g>
		<g>
			<path fill="#241247" d="M22.521,8.1c-0.642-1.573-1.663-2.682-2.411-2.682c-0.089,0-0.175,0.016-0.255,0.048
				c-0.003,0.001-0.005,0.002-0.006,0.004l-1.104,0.483c-1.165-1.627-2.791-2.9-4.686-3.633c0.006-0.032,0.012-0.066,0.012-0.102
				c0-0.265-0.216-0.479-0.481-0.479c-0.193,0-0.359,0.115-0.435,0.279c-0.896-0.253-1.842-0.389-2.819-0.389
				c-0.676,0-1.338,0.065-1.979,0.19L7.809,0.65C7.609,0.224,7.096-0.001,6.459,0C5.998,0,5.473,0.118,4.956,0.36
				c-1.23,0.577-1.949,1.642-1.603,2.379L3.89,3.887c-0.802,0.64-1.507,1.398-2.088,2.248C1.713,6.034,1.584,5.969,1.439,5.969
				c-0.265,0-0.479,0.215-0.479,0.48c0,0.223,0.152,0.41,0.357,0.463C0.479,8.407,0,10.13,0,11.965c0,0.777,0.086,1.536,0.25,2.264
				C0.101,14.311,0,14.468,0,14.65c0,0.265,0.216,0.479,0.48,0.479c0.005,0,0.01,0,0.015,0c0.395,1.228,1.011,2.355,1.805,3.334
				l-0.52,0.614c-0.526,0.621-0.113,1.837,0.922,2.716c0.633,0.54,1.354,0.827,1.938,0.827c0.371,0,0.687-0.116,0.89-0.357
				l0.69-0.816c1.262,0.548,2.652,0.854,4.115,0.854c1.513,0,2.95-0.325,4.245-0.911c0.068,0.183,0.243,0.313,0.45,0.313
				c0.265,0,0.48-0.214,0.48-0.479c0-0.098-0.029-0.189-0.08-0.264c1.574-0.894,2.892-2.19,3.811-3.747
				c0.071,0.042,0.153,0.065,0.243,0.065c0.266,0,0.48-0.214,0.48-0.479c0-0.192-0.113-0.357-0.276-0.434
				c0.542-1.149,0.878-2.414,0.96-3.746l1.806-0.772C23.21,11.54,23.239,9.862,22.521,8.1z M4.425,1.936
				c0.214-0.273,0.548-0.523,0.938-0.708c0.37-0.173,0.76-0.269,1.096-0.269c0.288,0,0.433,0.069,0.477,0.1
				c-0.004,0.05-0.041,0.192-0.199,0.395C6.522,1.727,6.188,1.977,5.799,2.16c-0.37,0.174-0.76,0.27-1.097,0.27
				c-0.286,0-0.433-0.07-0.477-0.1C4.229,2.28,4.266,2.138,4.425,1.936z M4.796,21.639c-0.022,0.008-0.069,0.022-0.156,0.022
				c-0.283,0-0.798-0.158-1.317-0.599c-0.328-0.277-0.584-0.608-0.72-0.927c-0.099-0.237-0.097-0.383-0.088-0.431
				c0.021-0.009,0.069-0.023,0.156-0.023c0.283,0,0.797,0.158,1.317,0.599c0.328,0.278,0.583,0.607,0.719,0.928
				C4.808,21.443,4.806,21.591,4.796,21.639z M20.272,11.736l-0.544,0.231l-0.037,0.591c-0.148,2.377-1.187,4.589-2.925,6.23
				c-1.747,1.646-4.03,2.553-6.431,2.553c-1.296,0-2.551-0.26-3.732-0.774l-0.654-0.284L5.554,20.75
				c-0.193-0.414-0.515-0.838-0.945-1.204c-0.432-0.366-0.903-0.616-1.345-0.738l0.28-0.331l-0.5-0.617
				c-0.662-0.818-1.177-1.729-1.531-2.713c-0.368-1.018-0.554-2.089-0.554-3.181c0-1.45,0.322-2.841,0.958-4.132
				c0.606-1.231,1.496-2.336,2.571-3.196L5.08,4.165L4.76,3.479l-0.042-0.09c0.456-0.003,0.976-0.12,1.488-0.359
				c0.512-0.24,0.935-0.564,1.229-0.915l0.053,0.112l0.317,0.677L8.54,2.763C9.13,2.648,9.734,2.59,10.335,2.59
				c0.772,0,1.539,0.093,2.279,0.279c0.72,0.178,1.418,0.446,2.076,0.79c1.291,0.679,2.422,1.665,3.273,2.854l0.454,0.633
				l0.712-0.313l0.142-0.062c-0.017,0.682,0.156,1.551,0.52,2.441c0.372,0.913,0.872,1.668,1.371,2.144L20.272,11.736z
				 M22.048,10.845c-0.113-0.078-0.269-0.21-0.453-0.426c-0.343-0.404-0.668-0.96-0.916-1.567s-0.405-1.232-0.442-1.761
				c-0.02-0.282,0-0.488,0.026-0.622c0.112,0.078,0.268,0.211,0.453,0.428c0.343,0.403,0.668,0.96,0.916,1.566
				c0.247,0.606,0.405,1.232,0.44,1.761C22.094,10.506,22.074,10.711,22.048,10.845z"/>
			<path fill="#241247" d="M14.371,6.809c0.119-0.926-0.852-1.812-2.166-1.98c-0.147-0.02-0.292-0.03-0.434-0.03
				c-1.127,0-2.057,0.576-2.162,1.397c-0.119,0.927,0.851,1.813,2.165,1.982c0.146,0.018,0.292,0.027,0.434,0.027
				C13.336,8.206,14.265,7.63,14.371,6.809z M13.418,6.688c-0.019,0.144-0.172,0.261-0.262,0.319
				c-0.239,0.152-0.584,0.239-0.948,0.239c-0.103,0-0.208-0.006-0.312-0.02c-0.858-0.11-1.372-0.618-1.335-0.906
				C10.581,6.174,10.734,6.056,10.824,6c0.238-0.153,0.584-0.241,0.948-0.241c0.103,0,0.208,0.007,0.312,0.02
				C12.942,5.89,13.456,6.399,13.418,6.688z"/>
			<path fill="#241247" d="M14.672,13.858c-0.386,0-0.793,0.114-1.163,0.35c-0.905,0.58-1.24,1.672-0.749,2.441
				c0.291,0.455,0.807,0.694,1.366,0.694c0.387,0,0.794-0.114,1.164-0.351c0.905-0.578,1.24-1.67,0.749-2.44
				C15.748,14.097,15.232,13.858,14.672,13.858z M15.271,15.563c-0.075,0.24-0.256,0.467-0.498,0.622
				c-0.201,0.128-0.431,0.199-0.646,0.199c-0.119,0-0.412-0.024-0.557-0.251c-0.114-0.176-0.075-0.384-0.041-0.493
				c0.072-0.24,0.254-0.467,0.497-0.621c0.201-0.129,0.43-0.199,0.646-0.199h0.001c0.119,0,0.411,0.023,0.557,0.25
				C15.342,15.246,15.304,15.455,15.271,15.563z"/>
			<path fill="#241247" d="M6.924,9.599c-1.855,0-3.359,1.29-3.359,2.879c0,1.591,1.504,2.881,3.359,2.881
				c1.856,0,3.36-1.29,3.36-2.881C10.284,10.888,8.78,9.599,6.924,9.599z M8.675,13.786c-0.46,0.396-1.082,0.612-1.751,0.612
				c-0.668,0-1.29-0.217-1.75-0.612c-0.418-0.358-0.648-0.822-0.648-1.308c0-0.483,0.23-0.947,0.648-1.308
				c0.46-0.394,1.082-0.611,1.75-0.611c0.67,0,1.291,0.217,1.751,0.611c0.418,0.36,0.649,0.824,0.649,1.308
				C9.324,12.964,9.093,13.428,8.675,13.786z"/>
		</g>
	</g>
</g>
</svg>

`;

export default planetSVG



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/planetSVG.js